<div class="container">
  RESUMEN <br />
  Para el resumen utilice el formato propuesto a continuación: <br />
  "<span class="editable negrita color1" contenteditable="true" data-placeholder="ESCRIBA AQUÍ EL TITULO CORTO DEL PROYECTO" (input)="onInput($event, 'value1')"
    (blur)="onInputBlur('value1', $event)">{{value1 || ''}}</span>"
    <!-- (blur)="onInputBlur('value1', $event)">ESCRIBA AQUI EL TITULO CORTO DEL PROYECTO</span>" -->
  (Título corto del proyecto) es un proyecto liderado por
  <span class="editable negrita color2" contenteditable="true" data-placeholder="ESCRIBA AQUÍ EL NOMBRE DE LA ENTIDAD" (input)="onInput($event, 'value2')"
    (blur)="onInputBlur('value2', $event)">{{value2}}</span>
  (nombre de la entidad), con el objetivo de
  <span class="editable negrita color3" contenteditable="true" data-placeholder="ESCRIBA AQUÍ EL OBJETIVO RESUMIDO DEL PROYECTO" (input)="onInput($event, 'value3')"
    (blur)="onInputBlur('value3', $event)">{{value3}}</span>
  (objetivo resumido). Desde el (año)
  <span class="editable negrita color4" contenteditable="true" data-placeholder="ESCRIBA AQUÍ EL AÑO DE INICIO DEL PROYECTO" (input)="onInput($event, 'value4')"
    (blur)="onInputBlur('value4', $event)">{{value4}}</span>
  hemos logrado
  <span class="editable negrita color5" contenteditable="true" data-placeholder="ESCRIBA AQUÍ LOS LOGROS DEL PROYECTO" (input)="onInput($event, 'value5')"
    (blur)="onInputBlur('value5', $event)">{{value5}}</span>
  (poner logros con indicadores del proyecto desde que está en ejecución).
</div>
<br />
<div *ngIf="example == true" class="container">
  Ejemplo: <br />
  <span class="negrita color1" contenteditable="false">"Escuelas De Emprendimiento Joven Rural"</span>
  es un proyecto liderado por
  <span class="negrita color2" contenteditable="false">Ministerio de Agricultura y Ganadería</span>,
  con el objetivo de
  <span class="negrita color3" contenteditable="false">reactivar la ruralidad a trávez del apoyo y fomento de
    la implementacion de agro-emprendimiento tecnológicos liderados por jovenes de ruralidad</span>.
  Desde el
  <span class="negrita color4" contenteditable="false">2020</span> hemos logrado
  <span class="negrita color5" contenteditable="false">capacitar a mas de 2300 jovenes en habilidades blandas
    de emprendimiento, asi como habilidades técnicas agregadoras de valor. Por medio de hackatones, se han asignado
    aproximadamente 100 mil dólares en créditos a 147 ideas de emprensimientos de jóvenes</span>.
</div>


<!-- <div class="container">
  "<input type="text" class="editable negrita" placeholder="Ejemplo de Título" [style.width.px]="calculateInputWidth(value1)" (input)="onInput($event, 'value1')" (blur)="onInputBlur('value1', $event)" [(ngModel)]="value1">"
  (Título corto del proyecto) es un proyecto liderado por 
  "<input type="text" class="editable negrita" placeholder="Entidad Ejemplo" [style.width.px]="calculateInputWidth(value2)" (input)="onInput($event, 'value2')" (blur)="onInputBlur('value2', $event)" [(ngModel)]="value2">"
  (nombre de la entidad), con el objetivo de 
  "<input type="text" class="editable negrita" placeholder="Objetivo Ejemplo" [style.width.px]="calculateInputWidth(value3)" (input)="onInput($event, 'value3')" (blur)="onInputBlur('value3', $event)" [(ngModel)]="value3">"
  (poner el objetivo). Desde el (año) 
  "<input type="text" class="editable negrita" placeholder="2024" [style.width.px]="calculateInputWidth(value4)" (input)="onInput($event, 'value4')" (blur)="onInputBlur('value4', $event)"[(ngModel)]="value4">"
  (poner logros con indicadores del proyecto desde que está en ejecución).
</div>
  -->

<!-- <div class="container">
  <input type="text" class="editable" placeholder="Ejemplo de Título" (change)="onInputChange('value1', $event)" (blur)="onInputBlur('value1', $event)" [(ngModel)]="value1">
  (Título corto del proyecto) es un proyecto liderado por 
  <input type="text" class="editable" placeholder="Entidad Ejemplo" (change)="onInputChange('value2', $event)" (blur)="onInputBlur('value2', $event)" [(ngModel)]="value2">
  (nombre de la entidad), con el objetivo de 
  <input type="text" class="editable" placeholder="Objetivo Ejemplo" (change)="onInputChange('value3', $event)" (blur)="onInputBlur('value3', $event)" [(ngModel)]="value3">
  (poner el objetivo). Desde el (año) 
  <input type="text" class="editable" placeholder="2024" (change)="onInputChange('value4', $event)" (blur)="onInputBlur('value4', $event)" [(ngModel)]="value4">
  (poner logros con indicadores del proyecto desde que está en ejecución). -->
<!-- </div> -->